import ColumnTypes from '@/utils/ColumnTypes';
export const getColums = that => {
	let arr = [
		{
			key: 'shopDetails',
			label: '达人信息',
			type: () => import('./components/tableCell/myTlentInfo'),
			fixed: 'left',
			minWidth: '250',
			isAuth: true,
			show: true,
		},
		{
			key: 'fans_num',
			label: '粉丝数',
			type: 'rdText',
			bigger: true,
			minWidth: '100',
			isAuth: true,
			show: true,
		},
		{
			key: 'liveCommerce',
			label: '直播带货数据',
			type: () => import('./components/tableCell/liveCommerce'),
			minWidth: '200',
			helpNum: 3,
			helpDesc1: '场均销售额：近30天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播',
			helpDesc2: '直播观看人数：近30天卖货直播的观看人数的中位数',
			helpDesc3: '直播带货场次：近30天带货直播场次数量，剔除开播时间小于25分钟的直播',
			isAuth: that.$isDy(that.platformId),
			show: true,
		},
		{
			key: 'shortVideoCommerce',
			label: '短视频带货数据',
			type: () => import('./components/tableCell/shortVideoCommerce'),
			minWidth: '200',
			helpNum: 2,
			helpDesc1: '带货短视频：近30天发布且挂商品链接的短视频数量',
			helpDesc2: '带货商品数：近30天短视频带货的商品种类',
			isAuth: that.$isDy(that.platformId),
			show: true,
		},
		{
			key: 'goods_tag',
			label: '达人标签',
			type: () => import('./components/tableCell/goodsTag'),
			minWidth: '150',
			isAuth: that.$auth.hasPermi('team-sea:search-tags'),
			show: true,
		},
		{
			key: 'fee_30',
			label: '30日销售额',
			type: 'rdText',
			minWidth: '170',
			isAuth: that.$isKs(that.platformId) || that.$isSp(that.platformId),
			show: true,
		},
		{
			key: 'live_sale',
			label: '场均销售额',
			type: 'rdText',
			minWidth: '170',
			isAuth: true,
			show: true,
		},
		{
			key: 'cooperate_status_name',
			label: '合作状态',
			type: 'rdText',
			minWidth: '170',
			helpNum: 1,
			helpDesc1: '若同达人有多达人运营跟进则展示最深合作状态',
			isAuth: true,
			show: true,
		},
		{
			key: 'dealData',
			label: '成交数据',
			type: () => import('./components/tableCell/dealData'),
			minWidth: '170',
			helpNum: 1,
			helpDesc1: '团队所有商务给达人推品所产生的近180天成交数据',
			isAuth: that.$isDy(that.platformId) || that.$isKs(that.platformId),
			show: true,
		},
		{
			key: 'apply_num',
			label: '申样数',
			type: 'rdText',
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '已创建样品订单数',
			show: true,
			isAuth: true,
		},
		{
			key: 'send_num',
			label: '寄样数',
			type: 'rdText',
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '已发货样品订单数',
			show: true,
			isAuth: true,
		},
		{
			key: 'delivery_num',
			label: '交付数',
			type: 'rdText',
			helpNum: 1,
			helpDesc1: '已交付合作关联的样品订单数',
			minWidth: '100',
			show: true,
			isAuth: true,
		},
		{
			key: 'total_settle_amount',
			label: '30日成交金额',
			type: 'rdText',
			minWidth: '120',
			show: that.$isSp(that.platformId),
			isAuth: true,
		},
		{
			key: 'total_settle_item_num',
			label: '30日成交商品数',
			type: 'rdText',
			minWidth: '120',
			show: that.$isSp(that.platformId),
			isAuth: true,
		},
		{
			key: 'partnersName',
			label: '当前跟进人',
			type: () => import('./components/tableCell/partnersName'),
			minWidth: '170',
			isAuth: true,
			show: true,
		},
		{
			key: 'follow_time',
			label: '最近跟进时间',
			type: 'rdText',
			minWidth: '170',
			isAuth: true,
			show: true,
		},
		{
			key: 'add_time',
			label: '创建时间',
			type: 'rdText',
			minWidth: '170',
			isAuth: true,
			show: true,
		},
		{
			key: 'claim_desc',
			label: '认领状态',
			type: () => import('./components/tableCell/claimDesc'),
			minWidth: '180',
			isAuth: true,
			show: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			fixed: 'right',
			align: 'right',
			isAuth: true,
			show: true,
		},
	];
	return arr;
};
